import { useState, useEffect, useCallback } from 'react';
import { getSettings, saveSettings } from '@/lib/storage';
import type { Settings, Theme, TextSize, AvatarId } from '@/types';

export function useSettings() {
  const [settings, setSettings] = useState<Settings>(getSettings());

  useEffect(() => {
    // Appliquer le thème au chargement
    applyTheme(settings.theme);
    applyTextSize(settings.textSize);
  }, []);

  const updateTheme = useCallback((theme: Theme) => {
    setSettings((prevSettings) => {
      const newSettings = { ...prevSettings, theme };
      saveSettings(newSettings);
      return newSettings;
    });
    applyTheme(theme);
  }, []);

  const updateTextSize = useCallback((textSize: TextSize) => {
    setSettings((prevSettings) => {
      const newSettings = { ...prevSettings, textSize };
      saveSettings(newSettings);
      return newSettings;
    });
    applyTextSize(textSize);
  }, []);

  const updateAvatar = useCallback((avatar: AvatarId) => {
    setSettings((prevSettings) => {
      const newSettings = { ...prevSettings, avatar };
      saveSettings(newSettings);
      return newSettings;
    });
  }, []);

  return {
    settings,
    updateTheme,
    updateTextSize,
    updateAvatar,
  };
}

function applyTheme(theme: Theme) {
  const html = document.documentElement;

  // Retirer toutes les classes de thème
  html.classList.remove('dark', 'theme-oled');

  // Appliquer le nouveau thème
  if (theme === 'dark') {
    html.classList.add('dark');
  } else if (theme === 'oled') {
    html.classList.add('dark', 'theme-oled');
  }
}

function applyTextSize(size: TextSize) {
  const html = document.documentElement;

  // Retirer toutes les classes de taille
  html.classList.remove('text-size-small', 'text-size-normal', 'text-size-large', 'text-size-xlarge');

  // Appliquer la nouvelle taille
  html.classList.add(`text-size-${size}`);
}
